<p *ngFor="let item of data" class="c-text">
  <span class="u-font-weight-700">{{item.title}}:</span>
  {{item.value}}
</p>